import React from 'react';
import { routes } from 'constants/config';
import { chromeExtensionMappings } from 'selectors/pathBuilder';
import { Icon } from 'ui';
import ContentMappingBase from './partials/ContentMappingBase';

const renderRelatedUrl = relatedUrl => (
  <div>
    {relatedUrl.url}
    {relatedUrl.metadata && (
      <span className="fz-base c-brand-gray-light h-c-gray-darker ml-4">
        <Icon
          name="code"
          data-html="true"
          data-toggle="tooltip"
          data-original-title={relatedUrl.metadata}
        />
      </span>
    )}
  </div>
);

export default ContentMappingBase({
  displayName: 'ChromeMappings',
  mappingsSelector: chromeExtensionMappings,
  header: 'Chrome Extension',
  headerTooltip:
    'Only learners who can see this content in the Learning Library will see it in Lessonly for Chrome.',
  UIStateKey: 'chromeExtension',
  contentMappingProps: {
    addButtonText: 'Add to Chrome Extension',
    removeTooltip: 'Remove Chrome extension Mapping',
    viewMappingsText: 'View all mapped content and URLs',
    renderMapping: mapping => renderRelatedUrl(mapping.relatedUrl),
    viewMappingsUrl: routes.RELATED_URLS,
    suggestionsProps: {
      placeholder: "Add a related website's URL",
      url: routes.RELATED_URLS_FILTER,
      queryParam: 'url',
      mapResponseToSuggestions: response => response.matchedUrls,
      getSuggestionValue: suggestion => suggestion.url,
      renderSuggestion: suggestion => renderRelatedUrl(suggestion),
    },
  },
});
